import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [waitingServiceWorker, setWaitingServiceWorker] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Listen for update available message from main app
    const handleUpdateAvailable = (event) => {
      if (event.detail && event.detail.type === 'UPDATE_AVAILABLE') {
        setWaitingServiceWorker(event.detail.registration);
        setShowUpdate(true);
        setIsUpdating(false); // Reset updating state
      }
    };

    window.addEventListener('updateAvailable', handleUpdateAvailable);
    
    return () => {
      window.removeEventListener('updateAvailable', handleUpdateAvailable);
    };
  }, []);

  const handleUpdate = () => {
    if (waitingServiceWorker && waitingServiceWorker.waiting && !isUpdating) {
      setIsUpdating(true);
      console.log('User clicked update - sending SKIP_WAITING message');
      waitingServiceWorker.waiting.postMessage({ type: 'SKIP_WAITING' });
      
      // Reload the page after service worker activates
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('New service worker activated - reloading page');
        window.location.reload();
      });

      // Auto-hide the notification after sending the message
      setTimeout(() => {
        setShowUpdate(false);
      }, 1000);

       } else if (!isUpdating) {
      // The new service worker already activated itself (skipWaiting on
      // install), so there is nothing left to message — the page just needs
      // a reload to fetch the new bundle.
      setIsUpdating(true);
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
    setIsUpdating(false);
  };

  return (
    <Snackbar
      open={showUpdate}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={handleDismiss}
    >
      <Alert
        severity="info"
        variant="filled"
        action={
          <div>
            <Button 
              color="inherit" 
              size="small" 
              onClick={handleUpdate}
              disabled={isUpdating}
              startIcon={isUpdating ? <CircularProgress size={16} color="inherit" /> : null}
            >
              {isUpdating ? 'UPDATEN...' : 'UPDATE'}
            </Button>
            {/* <Button 
              color="inherit" 
              size="small" 
              onClick={handleDismiss}
              disabled={isUpdating}
            >
              LATER
            </Button> */}
          </div>
        }
      >
        {t('updateNotification')}
      </Alert>
    </Snackbar>
  );
};

export default UpdateNotification; 